import LeftNavigationContent from "@components/Layouts/CatalogLayout/LeftNavigation/LeftNavigationContent";
import type { ItemLink } from "@ext/navigation/NavigationLinks";
import { createContext, type ReactElement, useContext, useState } from "react";

export type LeftNavViewContentComponent = ({
	itemLinks,
	closeNavigation,
}: {
	itemLinks: ItemLink[];
	closeNavigation?: () => void;
}) => JSX.Element;

const LeftNavViewContentContext = createContext<LeftNavViewContentComponent>(undefined);
let SetLeftNavViewContent: React.Dispatch<React.SetStateAction<LeftNavViewContentComponent>>;

abstract class LeftNavViewContentService {
	static Provider({ children }: { children: ReactElement }): ReactElement {
		const [leftNavViewContent, setLeftNavViewContent] = useState<LeftNavViewContentComponent>(
			() => LeftNavigationContent,
		);

		SetLeftNavViewContent = setLeftNavViewContent;

		return (
			<LeftNavViewContentContext.Provider value={leftNavViewContent}>
				{children}
			</LeftNavViewContentContext.Provider>
		);
	}

	static get value(): LeftNavViewContentComponent {
		return useContext(LeftNavViewContentContext);
	}

	static setView(component: LeftNavViewContentComponent) {
		SetLeftNavViewContent(() => component);
	}

	static setDefaultView() {
		LeftNavViewContentService.setView(LeftNavigationContent);
	}
}

export default LeftNavViewContentService;
